import { HStack, Image, Text } from '@chakra-ui/react'
import { FacebookShareButton } from 'react-share'

export const FacebookShare = (): React.ReactElement => {
  const url = global.window && window.location.href

  return (
    <FacebookShareButton url={url}>
      <HStack
        sx={{
          bg: '#1877f2',
          color: 'white',
          borderRadius: '4px',
          fontSize: '13px',
          height: '28px',
          p: '0 8px',
        }}
      >
        <Image src={'/icons/fb-share.png'} sx={{ boxSize: '16px' }} />
        <Text sx={{ lineHeight: 1 }}>Share</Text>
      </HStack>
    </FacebookShareButton>
  )
}
